export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/joshua-earlesz-314904bac3c9b06aaa39c8a28a84eb77.jpg";